import React from 'react';
import MasterPage from './MasterPage';
import Pricing from './Pricing';
import Footer from '../base/Footer';

const About = () => {
    return (
        <MasterPage>
            <div className="min-h-screen bg-white text-gray-800">
                <section className="bg-blue-50 py-14 px-6 md:px-20 text-center">
                    <h1 className="text-4xl md:text-5xl font-bold text-blue-600 mb-4">About Doctora</h1>
                    <p className="text-lg md:text-xl max-w-2xl mx-auto">
                        Doctora is a smart OPD management system that helps clinics handle patient flow with ease,
                        speed, and accuracy — no more paperwork.
                    </p>
                </section>

                <section className="py-12 px-6 md:px-20">
                    <h2 className="text-3xl font-semibold text-blue-600 mb-4">About Cubicle Eight</h2>
                    <p className="text-gray-700 leading-relaxed text-sm md:text-base">
                        CUBICLE Eight is the fastest growing provider of ICT Products and Services across India.
                        Our services include Telecommunication, ELV Solutions, Networking Infrastructure,
                        Security, Home & Office Automation, Hardware Supplies, and Maintenance Contracts.
                        <br /><br />
                        Our vision is to deliver top-tier IT solutions and superior service, enabling customers
                        to scale and grow through technology.
                    </p>
                </section>

                <section className="py-10 px-6 md:px-20 bg-gray-50">
                    <h2 className="text-3xl font-semibold text-blue-600 mb-4">Vision</h2>
                    <p className="text-gray-700 text-sm md:text-base leading-relaxed">
                        We focus on constant innovation to become a global leader by delivering superior quality solutions.
                        Let’s connect if you already have ideas — we offer free consultation and quotations.
                    </p>
                </section>

                <section className="py-10 px-6 md:px-20">
                    <h2 className="text-3xl font-semibold text-blue-600 mb-4">Mission & Values</h2>
                    <p className="text-gray-700 text-sm md:text-base leading-relaxed">
                        Our mission is to provide result-driven, cost-effective, and functional IT solutions.
                        We value people, customer satisfaction, and product quality above all.
                    </p>
                </section>

                <section className="py-10 px-6 md:px-20 bg-gray-50">
                    <h2 className="text-3xl font-semibold text-blue-600 mb-4">Our Team</h2>
                    <p className="text-gray-700 text-sm md:text-base leading-relaxed">
                        We are a passionate team — fun, curious, open-minded, and driven.
                        Life at Cubicle Eight is vibrant and empowering, both personally and professionally.
                    </p>
                </section>

                <section className="bg-indigo-50 py-16 px-6 md:px-20 text-center">
                    <h2 className="text-3xl font-semibold text-indigo-700 mb-6">Why We Started</h2>
                    <p className="text-lg max-w-3xl mx-auto text-gray-700 leading-relaxed">
                        We believe technology should make healthcare more human. Doctora was built to remove long waits
                        and confusion from patient care. From OPD systems to follow-up reminders — we simplify healthcare.
                    </p>
                </section>

                <section className="py-16 px-6 md:px-20">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-10">

                        <div className="bg-white p-8 rounded-2xl shadow-lg">
                            <h2 className="text-3xl font-bold text-indigo-600 text-center mb-4">Doctora Pricing</h2>
                            <p className="text-center text-gray-600 mb-8">
                                Transparent, pay-as-you-go pricing — no subscriptions or hidden fees.
                            </p>

                            <div className="flex flex-col sm:flex-row justify-around items-center gap-6">
                                <Pricing />
                            </div>
                        </div>

                        <div className="bg-white p-8 rounded-2xl shadow-lg">
                            <h2 className="text-2xl font-bold text-indigo-600 text-center mb-4">Refund & Cancellation Policy</h2>

                            <ul className="list-disc list-inside text-gray-600 text-sm mt-4 space-y-2">
                                <li><strong>No automatic charges</strong> — you're billed only for what you use.</li>
                                <li><strong>No cancellations</strong> — no subscriptions involved.</li>
                                <li>Used OPD credits are <strong>non-refundable</strong>.</li>
                                <li>Billing errors? Contact us within <strong>7 days</strong>.</li>
                            </ul>

                            <p className="text-sm text-gray-500 mt-6">
                                For billing support, email: <a href="mailto:info@doctora.live" className="text-indigo-600 underline">info@doctora.live</a>
                            </p>
                        </div>
                    </div>
                </section>
                <section><Footer /></section>
            </div>

        </MasterPage>

    );
};

export default About;
